import { getTotalPrice } from '../../common/utils/price';
export const getPrice = form => state => {
  return getTotalPrice(form, 'meal')(state);
};